import React from 'react';
import { motion } from 'framer-motion';

// Item 1: shared-panel morph between login and the register/onboarding flow.
// Both layers stay mounted (state persists). The left panel is pixel-identical
// in both, so the logo appears fixed while the right content cross-fades + rises.
const RegisterTransition: React.FC<{
  registering: boolean;
  login: React.ReactNode;
  onboarding: React.ReactNode;
}> = ({ registering, login, onboarding }) => {
  const container: React.CSSProperties = {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  };
  const layer: React.CSSProperties = { position: 'absolute', inset: 0 };

  return (
    <div style={container}>
      <motion.div
        style={{ ...layer, pointerEvents: registering ? 'none' : 'auto' }}
        animate={{ opacity: registering ? 0 : 1 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        {login}
      </motion.div>
      <motion.div
        style={{ ...layer, pointerEvents: registering ? 'auto' : 'none' }}
        initial={false}
        animate={{ opacity: registering ? 1 : 0, y: registering ? 0 : 14 }}
        transition={{ duration: 0.55, ease: [0.22, 0.61, 0.36, 1] }}
      >
        {onboarding}
      </motion.div>
    </div>
  );
};

export default RegisterTransition;
